import { render, staticRenderFns } from "./MerchantCenterTerm.vue?vue&type=template&id=738ded58&"
import script from "./MerchantCenterTerm.vue?vue&type=script&lang=ts&"
export * from "./MerchantCenterTerm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports